import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-right-circle-icon',
  templateUrl: './code-right-circle.component.html'
})
export class CodeRightCircleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
